import { Flex, type FlexProps } from 'antd';

export type AddonLayoutProps = Omit<FlexProps, 'vertical' | 'flex'>;

/**
 * AddonLayout — root of every Knowledge Hub add-on. The tab is the only
 * scroller: this fills the tab when the content is short and grows with it
 * when long, so no add-on sizes or scrolls itself (MED-7496).
 */
export const AddonLayout = (props: AddonLayoutProps) => (
  <Flex vertical flex="1 0 auto" {...props} />
);
